import React from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import CusButton from "../../../mui/custom_button/CusButton";
import IconGoogle from "../../../mui/JSXIcons/IconGoogle";
import "./google-auth.scss";
import { clientId } from "../../../../store/enums";
import ShowContainer from "../../../mui/ShowContainer";

export default function GoogleAuth() {
  const LoginButton = () => {
    const login = useGoogleLogin({
      onSuccess: (codeResponse) => {
        // Отправляем полученный code на сервер
        fetch("api/gamers/login_google", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code: codeResponse.code })
        })
          .then((res) => {
            const json = res.json();
            console.log("google res", json);
          })
          .then((data) => console.log("Пользователь авторизован:", data));
      },
      flow: "auth-code"
    });

    return (
      <CusButton
        className="login-button"
        color="primary"
        onClick={() => login()}
        icon={<IconGoogle />}
      />
    );
  };

  return (
    <ShowContainer condition={false}>
      <GoogleOAuthProvider clientId={clientId}>
        <LoginButton />
      </GoogleOAuthProvider>
    </ShowContainer>
  );
}
